import { useLocation } from 'react-router';
import { FieldOptionBase } from 'api/tasks';
import { UserOption } from 'components/molecules/squad-picker';
import { ofNullable, map, orElse } from 'core/maybe';
// eslint-disable-next-line import/no-internal-modules
import { useFilterUserOptions } from 'hooks/use-filter-user-options';
import { UsersMetadata } from '../fields';

export const useProjectIdFromUrl = () => {
  const { pathname } = useLocation();
  const projectIdString = ofNullable(
    pathname.match(/^\/projects\/(?<id>\d+).*/)?.groups?.id ?? null,
  );

  return map((value: string) => parseInt(value, 10))(projectIdString);
};

// @TODO This need to be refacetored to cater all type of users
// Currently this hook server all active users
// Check if there are other scenarios eg: we need to display only customer users
export const useUserOptions = (users: UsersMetadata) => {
  const optionalProjectId = useProjectIdFromUrl();

  const userOptions = useFilterUserOptions({
    projectId: optionalProjectId?.[1],
  });

  if (
    !!users?.non_external_user_ids &&
    users?.non_external_user_ids?.length !== 0
  ) {
    return orElse(users.non_external_user_ids)(
      map(
        (projectId: number) =>
          users.by_project_id[projectId]?.shared?.in_project_user_ids ?? [],
      )(optionalProjectId),
    ).map((userId) => ({
      ...UserOption(users.by_user_id[userId]),
      value: userId,
    }));
  }

  return userOptions as unknown as FieldOptionBase<number>[];
};
